module.exports = __webpack_public_path__ + "img/53.850daea9.svg";